import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import BrokerTasksTable from './BrokerTasksTable';
import { useTranslation } from 'react-i18next';


const BrokerTasks = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }} minHeight="100vh">
      <Box display="flex" flexDirection="column" width="100%">
        <Typography variant="h6" fontWeight={700} px={5} py={2.45}>
          {t("Tasks")}
        </Typography>
        <Divider />
        <Box p={5}>
          <Box display="flex" flexDirection="column">
            <BrokerTasksTable />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BrokerTasks;
